//
import axios from 'axios'

/**
 * 
 */
const update = async function ( id, data ) {
	//
    try {
        //
        const path     = '/wh_item/' + id
            , route    = process.env.VUE_APP_API_ROUTE.concat( path )
            , response = await axios.put( route, data )
		//
		return response.data
    } catch( error ) {
		//
        return error.response.data
    }
}

//
export default update
